import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSyringeBlue = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(3 3.04)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M13.33,8.24l4.16-4.16",
					transform: "translate(-3 -3.04)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M20.01,6.6l-4.15,4.16",
					transform: "translate(-3 -3.04)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M10.95,5.86l7.3,7.29",
					transform: "translate(-3 -3.04)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M6.65,17.45,3,21.1",
					transform: "translate(-3 -3.04)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M7.38,12.35l1.46,1.46",
					transform: "translate(-3 -3.04)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M9.57,10.16l1.46,1.46",
					transform: "translate(-3 -3.04)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M16.45,3.04,21,7.59",
					transform: "translate(-3 -3.04)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M16.845,11.748l-6.537,6.537a2,2,0,0,1-2.828,0l-1.607-1.6a2,2,0,0,1,0-2.828L12.41,7.315",
					transform: "translate(-3 -3.04)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M0,0H24V24H0Z"
		})
	]
});
export default SvgSyringeBlue;
